export function lockButton(button) {
	$(button).prop("disabled", true)
  fullscreenLoader.show()
}

export function unlockButton(button) {
	$(button).prop("disabled", false)
  fullscreenLoader.hide()
}